package com.shadowings.gero.util

import androidx.compose.runtime.Composable

// No calendar integration on web — CalendarPromptScreen is gated off by
// isCalendarIntegrationSupported() (false here), so this is never actually invoked.
@Composable
actual fun rememberCalendarEventLauncher(): (title: String, description: String, hour: Int, minute: Int) -> Unit {
    return { _, _, _, _ -> }
}
